<template>
    <div class="img_wrap">
        <div class="imgCont">
            <el-image class="imgs" :src="imgSrc!=null?imgSrc:imgs" fit="cover"></el-image>
            <p class="text" v-if="imgSrc==null"  :style="{ fontSize: computedFontSize + 'px' }">{{textCont}}</p>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        imgSrc:{
            type:String,
        },
        textCont:{
            type:String,
            default: null,
        },
        elementWidth:{
            type:Number,
            default:300,
        }
    },
    data(){
        return{
            imgs:require('@/assets/imgs/moudleImg.png'),
        }
    },
    computed: {
        computedFontSize() {
        // 根据元素宽度计算字体大小
        return Math.floor(this.elementWidth / 100) * 9;
        }
    },
}
</script>
<style lang="scss" scoped>
    .img_wrap,.imgCont{
        width:100%;
        height:100%;
        position:relative;
        .imgs{
            width:100%;
            height:100%;
        }
        .text{
            position:absolute;top:0;color:#fff;
            width: 100%;text-align: center;font-size:30px;font-weight:600;
            // text-shadow:1px 1px 1px #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
        }
    }
</style>